export default "<div *ngIf=\"lockBoard\" class=\"lock-board\">\r\n  <div class=\"content\">\r\n    Loading ...\r\n  </div>\r\n</div>";